import $ from 'jquery';

(function() {
    'use strict';

    squiz.starRatingForm = {

        'init': function() {

            var $form = $('.star-rating__wrapper form');

            $form.on('submit', squiz.starRatingForm.submitHandler);

            $form.find('.star-rating input[type="radio"]').on('change', function() {
                
                $form.submit();
                
            });
            
        },

        'submitHandler': function(e) {
            
            e.preventDefault();

            var form = this;

            // To prevent double submission
            // I'm adding a flag if submitting for the first time
            // First check if flag exists
            if ($(form).data().isSubmitted) {
                return false;
            }

            // If made past the check mark it as submitted and proceed
            $(form).data().isSubmitted = true;

            var formPostUrl = form.action + '?SQ_ASSET_CONTENTS_RAW';
            var formData = new FormData(form);
            var $submitButton = $(form).find('input[type="submit"]');
            formData.append($submitButton.attr('id'), 'Submit');

            $(form).find('.star-rating').addClass('hidden');
            $(form).find('.star-rating__loader').removeClass('hidden');
            
            /* Fake AJAX request in Dev environment
            if (squiz.utils.isDevelopment()) {
                
                console.log('AJAX postUrl: ', formPostUrl);
                
                for (var pair of formData.entries()) {
                    console.log(pair[0]+ ', ' + pair[1]); 
                }

                setTimeout(function() {
                    $(form).find('.star-rating__loader').addClass('hidden');
                    $(form).closest('.star-rating__inner').html(
                        '<h3 class="star-rating__heading">Rating received</h3>' +
                        '<fieldset class="star-rating__group">' + 
                            '<legend class="sq-form-question-title">Thank you for providing feedback on your experience</legend>' +
                            '<div class="star-rating__field">' + 
                                '<div class="star-rating__results" data-count="4"></div>' +
                            '</div>' +
                        '</fieldset>'
                    );
                    squiz.starRatingForm.setCookie();
                }, 500);
                return;
            }
*/
            var xhr = new XMLHttpRequest();
            xhr.open("POST", formPostUrl);
            
            xhr.onload = function() {
                $(form).find('.star-rating__loader').addClass('hidden');
                
                if (this.readyState == 4 && this.status == 200) {
                    $(form).closest('.star-rating__wrapper').find('.star-rating__error').empty();
                    $(form).closest('.star-rating__inner').html(this.responseText);
                    squiz.starRatingForm.setCookie();
                } else {
                    // Submission failed
                    $(form).find('.star-rating').removeClass('hidden');
                    $(form).data().isSubmitted = false;
                    $(form).closest('.star-rating__wrapper').find('.star-rating__error').html('There was a problem connecting. Please try again.');
                }
            }

            xhr.send(formData);
        },

        'setCookie': function() {
            var cookieName = 'tdc-star-rating-submitted';
            squiz.utils.setCookie(cookieName, '1', 90);
        }

    };

    $(document).ready(function() {
        if ($('.star-rating__wrapper form').length) {
            squiz.starRatingForm.init();
        }
    });

}());